import * as React from 'react';
import { TranslateFn, AnsViewComp } from '@wix/answers-app-core';
import { ChatUser, ChatGroupPositionType, ChatMessageStatus } from '../types';
import { ChatMessageType } from '@wix/answers-api';
import { classNames, prettyTimestamp } from '@wix/answers-lib/dist/utils';
import { UserAvatar, Tooltip } from '@wix/answers-ui-libby';

export const timelineBubbleKey = 'timeline-bubble';
export const userTimelineBubbleKey = 'timeline-bubble-user';
export const agentTimelineBubbleKey = 'timeline-bubble-agent';
export type TimelineBubbleProps = {
	timestamp: number;
	bubbleType: ChatMessageType;
	user?: ChatUser;
	children: React.ReactNode;
	groupPosition: ChatGroupPositionType;
	status?: ChatMessageStatus;
	onRetry: () => Promise<void>;
	disableTooltip?: boolean;
};

const translationPrefix = `widget-ng.chat.chat-room.chat-timeline.${timelineBubbleKey}`;

export type TimelineBubbleState = {
	retrying: boolean;
};

export class TimelineBubble extends AnsViewComp<TimelineBubbleProps, TimelineBubbleState> {

	state: TimelineBubbleState = {
		retrying: false
	};

	tp: TranslateFn = (key, params) => {
		return this.props.t(`${translationPrefix}.${key}`, params);
	}

	onRetry = () => {
		if (!this.state.retrying) {
			this.setState({retrying: true});
			this.props.onRetry().finally(() => this.setState({retrying: false}));
		}
	}

	render () {
		const {props} = this;
		const isUser = this.props.bubbleType === ChatMessageType.USER;
		const isOnly = this.props.groupPosition === ChatGroupPositionType.ONLY;
		const isFirst = this.props.groupPosition === ChatGroupPositionType.FIRST;
		const isMiddle = this.props.groupPosition === ChatGroupPositionType.MIDDLE;
		const isLast = this.props.groupPosition === ChatGroupPositionType.LAST;

		const timelineWrapperBubbleKey = classNames('timeline-item-wrapper', {
			user: isUser,
			agent: !isUser,
			only: isOnly,
			first: isFirst,
			middle: isMiddle,
			last: isLast,
			sending: props.status === ChatMessageStatus.SENDING

		});

		const messageTime = prettyTimestamp(this.props.timestamp);

		const tooltipBody = (
			<div className='tooltip-content'>
				<span className='tooltip-content-text'>{messageTime}</span>
			</div>
		);
		const showAvatar = !isUser && (isLast || isOnly);
		const failedMessage = (
			<div className='fail-info'>
				<span> {this.tp('fail-send')} </span>
				<span className='retry' onClick={this.onRetry}> {this.tp('retry')} </span>
			</div>
		);
		return (
			<div className='bubble-container'>
				<div className={timelineWrapperBubbleKey}>
					{showAvatar ? <UserAvatar className='agent-avatar' size='xsmall' user={props.user as any} isAgent={true} /> : null}
					<Tooltip className={'tooltip'} body={tooltipBody} forceHidden={this.props.disableTooltip}>
						<div className={timelineBubbleKey}>
							{props.children}
						</div>
					</Tooltip>
				</div>
				{this.props.status === ChatMessageStatus.FAIL ? failedMessage : null}
			</div>
		);
	}
}
